import { useQuery } from '@tanstack/react-query';
import { fetchSecurityGroupsForProduct } from '../services/security-groups';

export function useProductSecurityGroupsQuery(productId: string) {
  return useQuery({
    queryKey: ['security', 'products', productId, 'groups'],
    queryFn: () => fetchSecurityGroupsForProduct(productId),
    enabled: Boolean(productId),
  });
}
